<template lang="pug">
	.maps--statistics-info
		statistics-info-layout-item(:statistics="statistics", :config="config", :item="config.layout")
		Loader(v-if="isLoading", text="", :fullscreen="true")
</template>

<script>
	import Loader from 'app-core/Loader.vue';

	export default {
		translationCategory: 'maps.ZipsMap',
		name: 'maps--zips-map',
		components: { Loader },
		props: ['statistics', 'config'],
		data() {
			return {
				isLoading: 0,
				accentColor: '#dca0ff',
				subColor: '#dca0ff33',
				autoStyleField: null,
				format: 'thousands'
			};
		},
		computed: {
			totals() {
				return this.calculateTotals();
			}
		},
		watch: {
			
		},
		mounted() {
			if (__DEBUG__)
				window.statisticsInfo = this;
		},
		destroyed() {

		},
		methods: {

		}
	};
</script>

<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";

	.maps--statistics-info {
		padding: 20px;
	}
</style>
